export const fadeInContentAnimation = () => {
	const fadeInUpElements = document.querySelectorAll('.fade-in-up-content');

	fadeInUpElements.forEach((element) => {
		window.gsap.set(element, {
			opacity: 0,
			y: 40,
			duration: 0.85,
		});

		window.gsap.to(element, {
			opacity: 1,
			y: 0,
			duration: 0.85,
			scrollTrigger: {
				trigger: element,
				start: 'top 90%',
				end: 'bottom 100%',
				toggleActions: 'play none none reverse',
			},
		});
	});
};
